// extracted by mini-css-extract-plugin
export default {"container":"MenuPedidos_container__4--sa"};